import { useRef, useState } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { Bookmark, BookmarkCheck, RotateCcw } from 'lucide-react'
import { useAuthStore } from '@/store/auth'
import { savedApi, savedStatusKey } from '@/lib/savedApi'
import { applySavedEvent } from '@/lib/savedMessages'
import { describeError } from '@/lib/auth'
import { MenuItem } from '../ContextMenu'
import styles from './SaveMessageAction.module.css'

export function SaveMessageAction({ channelId, messageId, onClose }: { channelId: string; messageId: string; onClose: () => void }) {
  const userId = useAuthStore((s) => s.user?.id)
  const client = useQueryClient()
  const status = useQuery({ queryKey: savedStatusKey(userId, channelId, messageId), queryFn: () => savedApi.status(channelId, messageId), enabled: Boolean(userId), staleTime: 0 })
  const [pending, setPending] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const busy = useRef(false)
  const toggle = async () => {
    if (busy.current || !userId || !status.data) return
    busy.current = true; setPending(true); setError(null)
    try {
      const saved = status.data.saved
      await (saved ? savedApi.remove(channelId, messageId) : savedApi.save(channelId, messageId))
      applySavedEvent(client, userId, saved ? 'SAVED_MESSAGE_DELETE' : 'SAVED_MESSAGE_CREATE', { channel_id: channelId, message_id: messageId })
      onClose()
    } catch (err) { setError(describeError(err).message) }
    finally { busy.current = false; setPending(false) }
  }
  return <>
    {status.isError ? <MenuItem icon={<RotateCcw size={16} />} label="Повторить загрузку сохранённого" onClick={() => void status.refetch()} /> : <MenuItem icon={status.data?.saved ? <BookmarkCheck size={16} /> : <Bookmark size={16} />} label={pending ? status.data?.saved ? 'Убираем…' : 'Сохраняем…' : status.isPending ? 'Загружаем…' : status.data?.saved ? 'Убрать из сохранённого' : 'Сохранить сообщение'} disabled={pending || status.isFetching || !status.data} onClick={() => void toggle()} />}
    {error ? <p className={styles.error} role="alert">{error}</p> : null}
  </>
}
